import { BrowserRouter as Router, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import './App.css';

import Home from './Home';
import About from './About';
import Books from './Books';
import MalamFamilyHistory from './MalamFamilyHistory';
import FamilyTree from './FamilyTree';
import EdwardMalam from './EdwardMalam';
import Contact from './Contact';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/books" element={<Books />} />
        <Route path="/malamfamilyhistory" element={<MalamFamilyHistory />} />
        <Route path="/familytree" element={<FamilyTree />} />
        <Route path="/edwardmalam" element={<EdwardMalam />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </Router>
  );
}

export default App;
